import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesElakay from "./Routes";
import { installRoleSwitchFetchInterceptor } from "./includes/auth/roleSwitchFetch";
import { installSessionGuard } from "./includes/auth/sessionGuard";
import reportWebVitals from './reportWebVitals';
import { registerPwaUpdater } from './utils/pwaUpdate';
import PwaUpdatePrompt from './components/PwaUpdatePrompt';
import './animations-disabled.css';

 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';



import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import 'mdbreact/dist/css/mdb.css';

// Neutral application canvas. Scoped appearance settings in Layout/Header/
// Footer remain authoritative whenever the user enables custom colors.
import './styles/globalFoundation.css';

// Système de titres responsives par défaut (h1-h6 + utilitaires .elakay-*) —
// importé en dernier pour gagner sur les défauts h1-h6 de Bootstrap/MDB.
import './styles/responsiveTitles.css';
// Shared, device-aware gutters for every card/catalog grid. Imported after
// vendor CSS so individual pages cannot accidentally restore uneven spacing.
import './styles/cardGridSpacing.css';
// Opt-in stability overrides. They are inert until Animation Settings adds
// .elakay-motion-stable to <html>.
import './styles/motionStability.css';

// Le front démarre sans mouvement. Routes enlève cette classe uniquement
// lorsque le réglage global sauvegardé autorise explicitement les animations.
document.documentElement.classList.add('elakay-animations-disabled');


// import "@fortawesome/fontawesome-free/css/all.min.css";

// Elakay a définitivement retiré son système de mode nuit. D'anciens visiteurs
// peuvent encore avoir une clé de thème sombre en mémoire dans leur navigateur
// (posée par une version antérieure du site) : on la purge une fois au démarrage
// pour garantir que le thème clair reste seul utilisé. On ne touche qu'à ces
// clés précises — jamais à localStorage.clear() ni sessionStorage.clear().
(function cleanupLegacyDarkModeStorage() {
  const legacyThemeKeys = ['theme', 'darkMode', 'dark-mode', 'colorMode', 'color-mode', 'appearance'];
  try {
    legacyThemeKeys.forEach((key) => window.localStorage.removeItem(key));
    legacyThemeKeys.forEach((key) => window.sessionStorage.removeItem(key));
  } catch (e) {
    // localStorage/sessionStorage indisponible (navigation privée, etc.) : rien à faire.
  }
  document.documentElement.removeAttribute('data-theme');
  document.documentElement.removeAttribute('data-bs-theme');
  document.documentElement.classList.remove('dark', 'dark-mode', 'theme-dark');
  document.body?.classList.remove('dark', 'dark-mode', 'theme-dark');
})();

// ResizeObserver fires this benign notification when its callback triggers
// layout changes. The browser handles it gracefully but CRA's dev overlay
// treats it as an uncaught error — intercept it before it reaches the overlay.
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
});

// Switch Role / View As Role (Phase 1) -- installed once, before anything
// renders, so every fetch() the app makes from the very first render is
// eligible to carry the selected-role header. No-op (never adds anything)
// until a role switch is actually selected -- see includes/auth/roleSwitchFetch.js.
installRoleSwitchFetchInterceptor();
// Dead login (signed out in another tab, password changed...): clear it once
// instead of polling the API with a rejected token.
installSessionGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RoutesElakay />
    <PwaUpdatePrompt />
  </React.StrictMode>
);

// Registration happens after the first render and only in production. The
// worker never activates a new build until the user explicitly accepts it.
registerPwaUpdater();

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
